(() => {
  const initialize = (root = document) => {
    document.querySelectorAll('[data-dnd-overlay-header]').forEach((header) => {
      if (header.dataset.overlayReady) return;
      header.dataset.overlayReady = 'true';
      let pending = false;
      const update = () => {
        pending = false;
        const hero = document.querySelector('[data-dnd-hero]');
        header.classList.toggle('dnd-header--overlay', Boolean(hero));
        header.classList.toggle('dnd-header--scrolled', Boolean(hero && hero.getBoundingClientRect().bottom <= header.offsetHeight));
      };
      const onScroll = () => {
        if (!pending) { pending = true; requestAnimationFrame(update); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      document.addEventListener('shopify:section:load', update);
      document.addEventListener('shopify:section:unload', onScroll);
      header.dndCleanup = () => {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        document.removeEventListener('shopify:section:load', update);
        document.removeEventListener('shopify:section:unload', onScroll);
      };
      update();
    });
    root.querySelectorAll('[data-dnd-menu]').forEach((menu) => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const summary = menu.querySelector('summary');
      const close = (returnFocus = false) => {
        menu.open = false;
        summary.setAttribute('aria-expanded', 'false');
        if (returnFocus) summary.focus();
      };
      menu.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(menu.open));
        summary.setAttribute('aria-label', menu.open ? 'Menü schließen' : 'Menü öffnen');
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { event.preventDefault(); close(true); }
      });
      menu.addEventListener('focusout', () => {
        setTimeout(() => { if (!menu.contains(document.activeElement)) close(); }, 0);
      });
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => close()));
    });
    root.querySelectorAll('[data-dnd-hero]').forEach((hero) => {
      if (hero.dataset.ready) return;
      hero.dataset.ready = 'true';
      const template = hero.querySelector('[data-dnd-video-template]');
      if (!template) return;
      const toggle = hero.querySelector('[data-dnd-video-toggle]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let video;
      const update = () => {
        const playing = video && !video.paused;
        toggle.textContent = playing ? 'VIDEO PAUSIEREN' : 'VIDEO ABSPIELEN';
        toggle.setAttribute('aria-label', playing ? 'Video pausieren' : 'Video abspielen');
        hero.classList.toggle('dnd-hero--playing', Boolean(playing));
      };
      const loadVideo = () => {
        if (video) return video;
        hero.querySelector('.dnd-hero__media').append(template.content.cloneNode(true));
        video = hero.querySelector('video');
        video.addEventListener('play', update);
        video.addEventListener('pause', update);
        video.addEventListener('error', update);
        return video;
      };
      const play = () => loadVideo().play().catch(update);
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        if (!video || video.paused) play(); else video.pause();
      });
      if (!reducedMotion.matches && !navigator.connection?.saveData) play();
      const onMotionChange = () => { if (reducedMotion.matches) video?.pause(); };
      reducedMotion.addEventListener('change', onMotionChange);
      hero.dndCleanup = () => reducedMotion.removeEventListener('change', onMotionChange);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-dnd-hero], [data-dnd-overlay-header]').forEach((element) => element.dndCleanup?.());
  });
})();
